import "./App.css";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import Navbar from "./components/Navbar";
import HeroSection from "./components/HeroSection";
import OurMission from "./components/OurMission";
import JoinUs from "./components/JoinUs";
import FAQ from "./components/FAQ";
import GetTheApp from "./components/GetTheApp";
import HowItWorks from "./components/HowItworks";
import Footer from "./components/Footer";
import MechanicApp from "./components/MechanicApp";
import PrivacyPolicy from "./components/Privacy";
import TermsOfUse from "./components/TermsOfUse";
import ScrollToTop from "./components/ScrollToTop";
import AccountDeletionPolicy from "./components/DeletionTerms";

function HomePage() {
  return (
    <main>
      <section id="home">
        <HeroSection />
      </section>
      <section id="get-the-app">
        <GetTheApp />
      </section>
      <section id="how-it-works">
        <HowItWorks />
      </section>
      <section id="about">
        <OurMission />
      </section>
      <section id="join">
        <JoinUs />
      </section>
      <section id="faq">
        <FAQ />
      </section>
    </main>
  );
}

// Empty page fallback (for pages with no content)
function EmptyPage() {
  return (
    <div className="h-[70vh] flex items-center justify-center bg-[#F5F5F5] text-gray-600">
      <p>No content available for this page.</p>
    </div>
  );
}

function App() {
  return (
    <Router>
      <div className="flex flex-col min-h-screen">
        <ScrollToTop />
        <Navbar />

        {/* Main content wrapper */}
        <div className="flex-grow">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/get-the-app" element={<GetTheApp />} />
            <Route path="/join" element={<JoinUs />} />
            <Route path="/faq" element={<FAQ />} />
            <Route path="/about" element={<OurMission />} />
            <Route path="/mechanicApp" element={<MechanicApp />} />
            <Route path="/MechanicApp" element={<Navigate to="/mechanicApp" replace />} />
            <Route path="/Partner" element={<Navigate to="/#join" replace />} />
            <Route path="/job" element={<Navigate to="/#join" replace />} />
            <Route path="/Carmie" element={<Navigate to="/#about" replace />} />
            <Route path="/privacy" element={<PrivacyPolicy />} />
            <Route path="/terms" element={<TermsOfUse />} />
            <Route path="/deletion-terms" element={<AccountDeletionPolicy />} />
            <Route path="*" element={<EmptyPage />} />{" "}
            {/* Fallback for empty pages */}
          </Routes>
        </div>

        <Footer />
      </div>
    </Router>
  );
}

export default App;
